import debounce from "lodash/debounce";
import dwhExport from '~/dwhExport'
import PropTypes from "prop-types";
import * as React from "react";
import { getSearchClassForBody } from "helpers/search";
import { scrollToY } from "helpers/animate";
import styles from "./Search.scss";
import isObject from "lodash/isObject";
import ContainerPromo from "fe2/Containers/ContainerPromo";
import { SearchInput } from "components";
import { SearchResult } from "../UIKit/UIKit";
import { Divider, StepCSSTransitionGroup } from "@wg/wows-react-uikit";

const propTypes = {
  autocomplete: PropTypes.shape({
    foundByTerm: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired,
      hex_color: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    })),
    isFetching: PropTypes.bool.isRequired,
    meta: PropTypes.object
  }),
  battleTypes: PropTypes.array.isRequired,
  currentAccount: PropTypes.shape({
    id: PropTypes.number.isRequired,
    clanId: PropTypes.number
  }).isRequired,
  searchHistory: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired,
      hex_color: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    }))
  }),
  searchResult: PropTypes.shape({
    battleTypeSelected: PropTypes.string.isRequired,
    error: PropTypes.object,
    isFetchedBefore: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    meta: PropTypes.object,
    page: PropTypes.number.isRequired,
    term: PropTypes.string.isRequired
  }).isRequired,
  root: PropTypes.string.isRequired,

  onAutocompleteItemClick: PropTypes.func.isRequired,
  onBattleTypeChange: PropTypes.func.isRequired,
  clearState: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSearchInputChange: PropTypes.func.isRequired,
  joinClan: PropTypes.func.isRequired,

  onPageChanged: PropTypes.func,
  onReloadClick: PropTypes.func
};

const contextTypes = {
  router: PropTypes.object.isRequired
};

class Search extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      removeSearchState: true,
      promoSlide: 0
    };

    this.app = document.getElementById('app');
    this.afterChange = this.afterChange.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.onAutocompleteItemClick = this.onAutocompleteItemClick.bind(this);
    this.onClanClick = this.onClanClick.bind(this);

    this.onBattleTypeChange = this.wrapFetchResultMethod('onBattleTypeChange');
    this.onPageChanged = this.wrapFetchResultMethod('onPageChanged');
    this.onReloadClick = this.wrapFetchResultMethod('onReloadClick');
    this.onSubmit = this.wrapFetchResultMethod('onSubmit');
  }

  componentDidMount() {
    debounce(()=>{dwhExport.send('search.open_page')}, 1000)
    document.getElementById('app').scrollTop = 0;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {// eslint-disable-line
    if (!this.props.currentAccount.clanId) {
      const bodyClass = getSearchClassForBody(null, nextProps.searchResult.isFetchedBefore);
      document.body.className = bodyClass;
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps && prevProps.searchResult.page !== this.props.searchResult.page) {
      scrollToY(this.app);
    }
  }

  componentWillUnmount() {
    if (this.state.removeSearchState) {
      this.props.clearState();
    }
    this.abortRequest();
  }

  afterChange(currentSlide) {
    this.setState({
      promoSlide: currentSlide
    });
  }

  wrapFetchResultMethod(methodName) {
    return (...args) => {
      this.abortRequest();
      this.setState({
        request: this.props[methodName](...args)
      });
    };
  }

  abortRequest() {
    if (this.state.request) this.state.request.abort();
  }

  handleClearClick() {
    this.abortRequest();
    this.props.clearState();
  }

  onAutocompleteItemClick(item) {
    this.props.onAutocompleteItemClick(item, this.props.currentAccount.id);
  }

  onClanClick(clan) {
    dwhExport.send('search.open_clan', {
      clan_id: isObject(clan) ? clan.id : clan
    })
    this.setState({ removeSearchState: false }, () => {
      this.context.router.push(`${this.props.root}clan-profile/${isObject(clan) ? clan.id : clan}?source=search`)
    });
  }

  renderSearchInput() {
    const totalClans = this.props.autocomplete.meta && this.props.autocomplete.meta.total_clans;
    let isClanUser = Boolean(this.props.currentAccount.clanId);
    return <div className={styles.searchInputContainer}>
                {isClanUser ? <Divider type="major" /> : null}
                <div className={styles.searchInputWrap} data-staff-name="search_search-input">
                    <SearchInput key="search-input" autocompleteFoundByTerm={this.props.autocomplete.foundByTerm} autocompleteItems={this.props.autocomplete.items} autocompleteTotalClans={totalClans} isAutocompleteFetching={this.props.autocomplete.isFetching} isClanUser={isClanUser} searchHistory={this.props.searchHistory} term={this.props.searchResult.term} onAutocompleteItemClick={this.onAutocompleteItemClick} onHistoryItemClick={this.onClanClick} onClearClick={this.handleClearClick} onSearchInputChange={this.props.onSearchInputChange} onSubmit={this.onSubmit} />
                </div>
                {isClanUser ? <Divider type="major" /> : null}
            </div>;
  }

  renderPromo() {
    // if (!this.props.searchResult.isFetchedBefore && !this.props.currentAccount.clanId) {
    if (!this.props.searchResult.isFetchedBefore) {
      return <ContainerPromo router={this.context.router} />;
    } else {
      return null;
    }
  }

  renderSearchResult() {
    return this.props.searchResult.isFetchedBefore ? <SearchResult key="search-result" battleTypes={this.props.battleTypes} currentAccount={this.props.currentAccount} searchResult={this.props.searchResult} onItemClick={this.onClanClick} onBattleTypeChange={this.onBattleTypeChange} onPageChanged={this.onPageChanged} onReloadClick={this.onReloadClick} joinClan={this.props.joinClan} /> : null;
  }

  render() {
    return <div>
                <StepCSSTransitionGroup level={1}>
                    {this.renderSearchInput()}
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={2}>
                    {this.renderPromo()}
                    {this.renderSearchResult()}
                </StepCSSTransitionGroup>
            </div>;
  }
}

Search.propTypes = propTypes;
Search.contextTypes = contextTypes;

export default Search;